import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import Calculation from "./Calculation";
import Select from "react-tailwindcss-select";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import userResources from "api/userResources";

const Cruise = ({
  Cruise,
  register,
  errors,
  clearErrors,
  watch,
  setValue,
  getValues,
  control,
  updateData,
}) => {
  const [counties, setCounties] = useState([]);
  const [supplierData, setSupplierData] = useState([]);

  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getCountries = async () => {
    try {
      const response = await userResources.countries();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      // setCountryFilterData(response.data.data);

      setCounties(combinedData);

      if (updateData) {
        const toBoolean = (value) => String(value).toLowerCase() === "true";

        setValue(
          "cruise.cruiseDetails.cruise_name",
          updateData?.cruise?.cruiseDetails?.cruise_name
        );
        setValue(
          "cruise.cruiseDetails.country",
          Number(updateData?.cruise?.cruiseDetails?.country)
        );
        setValue(
          "cruise.cruiseDetails.start_date",
          updateData?.cruise?.cruiseDetails?.start_date
        );
        setValue(
          "cruise.cruiseDetails.end_date",
          updateData?.cruise?.cruiseDetails?.end_date
        );
        setValue(
          "cruise.cruiseDetails.operator",
          updateData?.cruise?.cruiseDetails?.operator
        );

        // cruise Calculation update
        // cruise
        setValue(
          `cruise.passengers.adt`,
          Number(updateData?.cruise?.passengers?.adt)
        );
        setValue(
          `cruise.passengers.chd`,
          Number(updateData?.cruise?.passengers?.chd)
        );
        setValue(
          `cruise.passengers.inf`,
          Number(updateData?.cruise?.passengers?.inf)
        );
        setValue(
          `cruise.cruise_from_pax.baseFare.adt1`,
          Number(updateData?.cruise.cruise_from_pax?.baseFare?.adt1)
        );
        setValue(
          `cruise.cruise_from_pax.baseFare.chd1`,
          Number(updateData?.cruise.cruise_from_pax?.baseFare?.chd1)
        );
        setValue(
          `cruise.cruise_from_pax.baseFare.inf1`,
          Number(updateData?.cruise.cruise_from_pax?.baseFare?.inf1)
        );
        setValue(
          `cruise.cruise_from_pax.gstHst.adt1`,
          Number(updateData?.cruise.cruise_from_pax?.gstHst?.adt1)
        );
        setValue(
          `cruise.cruise_from_pax.gstHst.chd1`,
          Number(updateData?.cruise.cruise_from_pax?.gstHst?.chd1)
        );
        setValue(
          `cruise.cruise_from_pax.gstHst.inf1`,
          Number(updateData?.cruise.cruise_from_pax?.gstHst?.inf1)
        );
        setValue(
          `cruise.cruise_from_pax.taxes.adt1`,
          Number(updateData?.cruise.cruise_from_pax?.taxes?.adt1)
        );
        setValue(
          `cruise.cruise_from_pax.taxes.chd1`,
          Number(updateData?.cruise.cruise_from_pax?.taxes?.chd1)
        );
        setValue(
          `cruise.cruise_from_pax.taxes.inf1`,
          Number(updateData?.cruise.cruise_from_pax?.taxes?.inf1)
        );
        setValue(
          `cruise.cruise_from_pax.amountPaid`,
          Number(updateData?.cruise.cruise_from_pax?.amountPaid)
        );
        setValue(
          `cruise.cruise_from_pax.refund`,
          Number(updateData?.cruise.cruise_from_pax?.refund)
        );
        setValue(
          `cruise.cruise_from_pax.refund_paid`,
          Number(updateData?.cruise.cruise_from_pax?.refund_paid)
        );
        setValue(
          `cruise.cruise_from_pax.payment_received_from_pax`,
          toBoolean(
            updateData?.cruise.cruise_from_pax?.payment_received_from_pax
          )
        );
        // Using supplierPax for the key and when accessing updateData
        setValue(
          `cruise.cruise_to_supplier.baseFare.adt1`,
          Number(updateData?.cruise.cruise_to_supplier?.baseFare?.adt1)
        );
        setValue(
          `cruise.cruise_to_supplier.baseFare.chd1`,
          Number(updateData?.cruise.cruise_to_supplier?.baseFare?.chd1)
        );
        setValue(
          `cruise.cruise_to_supplier.baseFare.inf1`,
          Number(updateData?.cruise.cruise_to_supplier?.baseFare?.inf1)
        );
        setValue(
          `cruise.cruise_to_supplier.gstHst.adt1`,
          Number(updateData?.cruise.cruise_to_supplier?.gstHst?.adt1)
        );
        setValue(
          `cruise.cruise_to_supplier.gstHst.chd1`,
          Number(updateData?.cruise.cruise_to_supplier?.gstHst?.chd1)
        );
        setValue(
          `cruise.cruise_to_supplier.gstHst.inf1`,
          Number(updateData?.cruise.cruise_to_supplier?.gstHst?.inf1)
        );

        setValue(
          `cruise.cruise_to_supplier.paymentMade`,
          Number(updateData?.cruise.cruise_to_supplier?.paymentMade)
        );
        setValue(
          `cruise.cruise_to_supplier.payment_received_from_supplier`,
          Number(
            updateData?.cruise?.cruise_to_supplier
              ?.payment_received_from_supplier
          )
        );
        setValue(
          `cruise.cruise_to_supplier.recall_commission_to_supplier`,
          Number(
            updateData?.cruise?.cruise_to_supplier
              ?.recall_commission_to_supplier
          )
        );
        setValue(
          `cruise.cruise_to_supplier.refund`,
          Number(updateData?.cruise?.cruise_to_supplier?.refund)
        );
        setValue(
          `cruise.cruise_to_supplier.cash_in_hand`,
          Number(updateData?.cruise?.cruise_to_supplier?.cash_in_hand)
        );

        setValue(
          `cruise.cruise_to_supplier.refund_received_from_supplier`,
          toBoolean(
            updateData?.cruise?.cruise_to_supplier
              ?.refund_received_from_supplier
          )
        );
        setValue(
          `cruise.cruise_to_supplier.payment_received_from_supplier`,
          Number(
            updateData?.cruise?.cruise_to_supplier
              ?.payment_received_from_supplier
          )
        );
        setValue(
          `cruise.cruise_to_supplier.commission_from_supplier`,
          toBoolean(
            updateData?.cruise?.cruise_to_supplier?.commission_from_supplier
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCountries();
    getSuppliers();
  }, []);

  return (
    <section className="p-2">
      <div>
        <p className="bg-[#bb8e25] px-2 text-white">Cruise:</p>
      </div>

      <div className="grid grid-cols-2 gap-x-2 sm:grid-cols-3">
        {/* Package Name Field */}
        <InputField
          label="Cruise Name"
          id="cruise_name"
          type="text"
          placeholder="Enter Package Name"
          register={register}
          name="cruise.cruiseDetails.cruise_name"
          rules={{ required: "Package Name is required" }}
          errorMessage={errors?.cruise?.cruiseDetails?.cruise_name?.message}
          onChange={() => clearErrors("cruise.cruiseDetails.cruise_name")}
          bgAllDark={true}
        />
        <div>
          <label className="my-2 block text-sm font-medium text-[#bb8e25]">
            Country
          </label>
          <Select
            {...register(`cruise.cruiseDetails.country`, {
              required: "Country is required",
            })}
            value={counties.find(
              (source) => source.value === watch("cruise.cruiseDetails.country") // Use watch to get the current value
            )} // Controlled value
            onChange={(selectedOption) => {
              setValue(
                "cruise.cruiseDetails.country",
                selectedOption?.value || ""
              ); // Update handler using setValue from React Hook Form
              clearErrors("cruise.cruiseDetails.country");
            }}
            options={counties} // Format options
            isSearchable={true} // Enable search functionality
            placeholder="Select..."
            classNames={getSelectClassNames({
              isDisabled: false,
              selectProps: {},
              isSelected: false,
              value: watch("cruise.cruiseDetails.country"), // Use watch to get the current value
            })} // Pass parameters here
            formatOptionLabel={(data) => (
              <li
                className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                  !data.isSelected
                    ? `bg-gray-200 text-gray-900`
                    : `bg-blue-800 text-gray-200`
                }`}
              >
                {data.label}
              </li>
            )}
          />
          {errors?.cruise?.cruiseDetails?.country && (
            <span className="text-sm text-red-500">
              {errors?.cruise?.cruiseDetails?.country?.message}
            </span>
          )}
        </div>

        {/* Start Date Field */}
        <InputField
          label="Start Date"
          id="start_date"
          type="date"
          register={register}
          name="cruise.cruiseDetails.start_date"
          rules={{ required: "Start Date is required" }}
          errorMessage={errors?.cruise?.cruiseDetails?.start_date?.message}
          onChange={() => clearErrors("cruise.cruiseDetails.start_date")}
          bgAllDark={true}
        />

        {/* End Date Field */}
        <InputField
          label="End Date"
          id="end_date"
          type="date"
          register={register}
          name="cruise.cruiseDetails.end_date"
          rules={{ required: "End Date is required" }}
          errorMessage={errors?.cruise?.cruiseDetails?.end_date?.message}
          onChange={() => clearErrors("cruise.cruiseDetails.end_date")}
          bgAllDark={true}
        />

        {/* Operator Field */}
        <InputField
          label="Operator"
          type="text"
          placeholder="Enter Operator"
          register={register}
          name="cruise.cruiseDetails.operator"
          // rules={{ required: "Operator is required" }}
          // errorMessage={errors?.cruise?.cruiseDetails?.operator?.message}
          // onChange={() => clearErrors("cruise.cruiseDetails.operator")}
          bgAllDark={true}
        />
      </div>

      <div className="mt-4">
        <Calculation
          supplierData={supplierData}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          watch={watch}
          setValue={setValue}
          control={control}
          getValues={getValues}
          Cruise={Cruise}
          cruisePax={true}
          cruiseSupplier={true}
          updateData={updateData}
        />
      </div>
    </section>
  );
};

export default Cruise;
